export default __webpack_public_path__ + "static/media/anh.e7d44397.jpg";